// src/services/authService.js
import axios from "../utils/axiosConfig";
import config from "../config/config";
import { handleError, extractValidationErrors } from "../utils/errorHandler";

const BASE_URL = `${config.apiUrl}/api/auth`;

export const authService = {
  register: async (userData) => {
    try {
      const response = await axios.post(`${BASE_URL}/register`, userData);
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      // Extraer errores de validación si existen
      const validationErrors = extractValidationErrors(error);
      if (Object.keys(validationErrors).length > 0) {
        throw new Error(Object.values(validationErrors).join(". "));
      }
      throw handleError(error);
    }
  },

  login: async (credentials) => {
    try {
      const response = await axios.post(`${BASE_URL}/login`, credentials);
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  logout: () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } catch (error) {
      throw handleError(error);
    }
  },

  getCurrentUser: () => {
    try {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    } catch (error) {
      throw handleError(error);
    }
  },

  getToken: () => {
    try {
      return localStorage.getItem("token");
    } catch (error) {
      throw handleError(error);
    }
  },

  isAuthenticated: () => {
    try {
      return !!authService.getToken();
    } catch (error) {
      throw handleError(error);
    }
  },

  updateProfile: async (userData) => {
    try {
      const response = await axios.put(`${BASE_URL}/profile`, userData);
      if (response.data.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      const validationErrors = extractValidationErrors(error);
      if (Object.keys(validationErrors).length > 0) {
        throw new Error(Object.values(validationErrors).join(". "));
      }
      throw handleError(error);
    }
  },

  verifyToken: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/verify`);
      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },
};

export default authService;
